// extracted by mini-css-extract-plugin
export default {"imgdiv":"_2330f67371 b972381811","img":"_76349d07e3 _7cd62b35e4"};